import axios from "axios";
import { toast } from "react-toastify";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

const handleError = (error) => {
  if (error.status === 401 && error.config.url !== 'login') {
    localStorage.removeItem("token");
    window.location.href = "/login";
  }
  if (error.response && error.response?.data?.message) {
    toast.error(error.response.data.message);
    return;
  }
  // Check if the error response exists and has a data field
  if (error.response && error.response?.data && error.response.data?.errors) {
    const { errors } = error.response.data;

    // Assuming the errors object is in the form { field1: ['error1', 'error2'], field2: ['error1'] }
    Object.keys(errors).forEach((field) => {
      errors[field].forEach((errorMsg) => {
        toast.error(errorMsg); // Display each error message with toast.error()
      });
    });
    return;
  } else {
    toast.error("An unexpected error occurred.");
  }
};

axiosInstance.interceptors.response.use(
  (res) => {
    res?.data?.message && toast.success(res?.data?.message);
    return res.data;
  },
  (error) => {
    console.log("error", error);
    handleError(error);
  }
);
